module.exports = __webpack_public_path__ + "static/media/checkbox1_light.ee3c1b77.svg";